import React from "react";
// react library for routing
import { NavLink as NavLinkRRD, Link } from "react-router-dom";
// nodejs library that concatenates classes
import classnames from "classnames";
// nodejs library to set properties for components
import { PropTypes } from "prop-types";
// react library that creates nice scrollbar on windows devices
import PerfectScrollbar from "react-perfect-scrollbar";
// reactstrap components
import {
  Collapse,
  NavbarBrand,
  Navbar,
  NavItem,
  NavLink,
  Nav
} from "reactstrap";
import { connect } from "react-redux";

class Sidebar extends React.Component {
  constructor(props) {

    super(props);
    this.state = {
      collapseOpen: false,
      ...this.getCollapseStates(props.routes)
    };
  }
  // verifies if routeName is the one active (in browser input)
  activeRoute = routeName => {
    return this.props.location.pathname.indexOf(routeName) > -1 ? "active" : "";
  };
  // makes the sidenav normal on hover (actually when mouse enters on it)
  onMouseEnterSidenav = () => {
    if (!document.body.classList.contains("g-sidenav-pinned")) {
      document.body.classList.add("g-sidenav-show");
    }
  };
  // makes the sidenav mini on hover (actually when mouse leaves from it)
  onMouseLeaveSidenav = () => {
    if (!document.body.classList.contains("g-sidenav-pinned")) {
      document.body.classList.remove("g-sidenav-show");
    }
  };
  // toggles collapse between opened and closed (true/false)
  toggleCollapse = () => {
    this.setState({
      collapseOpen: !this.state.collapseOpen
    });
  };
  // closes the collapse
  closeCollapse = () => {
    this.setState({
      collapseOpen: false
    });
  };
  // this creates the intial state of this component based on the collapse routes
  // that it gets through this.props.routes
  getCollapseStates = routes => {
    let initialState = {};
    routes.map((prop, key) => {
      if (prop.collapse) {
        initialState = {
          [prop.state]: this.getCollapseInitialState(prop.views),
          ...this.getCollapseStates(prop.views),
          ...initialState
        };
      }
      return null;
    });
    return initialState;
  };
  // this verifies if any of the collapses should be default opened on a rerender of this component
  // for example, on the refresh of the page,
  // while on the src/views/forms/RegularForms.jsx - route /admin/regular-forms
  getCollapseInitialState(routes) {
    for (let i = 0; i < routes.length; i++) {
      if (routes[i].collapse && this.getCollapseInitialState(routes[i].views)) {
        return true;
      } else if (window.location.href.indexOf(routes[i].path) !== -1) {
        return true;
      }
    }
    return false;
  }
  // this is used on mobile devices, when a user navigates
  // the sidebar will autoclose
  closeSidenav = () => {
    if (window.innerWidth < 1200) {
      this.props.toggleSidenav();
    }
  };

  renderClassnameColor = () => {
    if (window.location.pathname.split("/")[2] === "writer") {
      return "nav-link-writer";
    } else if (window.location.pathname.split("/")[2] === "editor") {
      return "nav-link-editor";
    } else if (window.location.pathname.split("/")[2] === "chief") {
      return "nav-link-chief";
    }
  };

  // this function creates the links and collapses that appear in the sidebar (left menu)
  createLinks = routes => {
    return routes.map((prop, key) => {
      let isDislayCount;

      switch (prop.name) {
        case "Pending":
          isDislayCount = `(${this.props.totalPending})`;
          break;

        case "Processed":
          isDislayCount = `(${this.props.totalProcessed})`;
          break;

        case "Official Tag":
          isDislayCount = `(${this.props.count_official_tags})`;
          break;

        case "Suggested Tag":
          isDislayCount = `(${this.props.count_suggest_tags})`;
          break;

        default:
          isDislayCount = "";
          break;
      }

      if (prop.seperate) {
        return (
          <div
            style={{
              borderBottom: "2px solid #ccc",
              width: "100%",
              margin: "5px 0 5px 55px"
            }}
          />
        );
      }
      if (prop.redirect) {
        return null;
      }
      if (prop.invisible) {
        return null;
      }
      //bug
      if (!this.props.mypermission.includes(prop.permission)) {
        return null;
      }
      if (prop.collapse) {
        var st = {};
        st[prop["state"]] = !this.state[prop.state];
        return (
          <NavItem key={key}>
            <NavLink
              data-toggle="collapse"
              aria-expanded={this.state[prop.state]}
              className={classnames(this.renderClassnameColor(), {
                active: this.getCollapseInitialState(prop.views)
              })}
              onClick={e => {
                e.preventDefault();
                this.closeCollapseBeforeOpen();
                this.setState(st);
              }}
              style={{ background: "none" }}
            >
              {prop.icon ? <i className={prop.icon} /> : null}
              <span className="nav-link-text">{prop.name}</span>
            </NavLink>
            <Collapse isOpen={this.state[prop.state]}>
              <Nav className="nav-sm flex-column">
                {this.createLinks(prop.views)}
              </Nav>
            </Collapse>
          </NavItem>
        );
      }

      return (
        <NavItem
          className={this.activeRoute(prop.path) + " cursor-pointer"}
          key={key}
        >
          <NavLink
            to={prop.path}
            className={this.renderClassnameColor()}
            onClick={this.closeSidenav}
            tag={NavLinkRRD}
            style={{ justifyContent: "space-between", background: "none" }}
          >
            {prop.icon !== undefined ? (
              <>
                <div>
                  <i className={prop.icon} /> &nbsp; &nbsp;
                  <span className="nav-link-text cursor-pointer">
                    {prop.name}
                  </span>
                </div>
                <span></span>
              </>
            ) : (
              <>
                <span className="d-flex nav-link-text cursor-pointer">
                  {`${prop.name} ${isDislayCount}`}
                  {this.props.hasTagToConvert && prop.name === 'Suggested Tag' ? <div className="m-1 alert-point" /> : <></>}
                </span>
              </>
            )}
          </NavLink>
        </NavItem>
      );
    });
  };

  closeCollapseBeforeOpen = () => {
    this.props.routes.forEach(prop => {
      if (prop.collapse) {
        this.setState({ [prop.state]: false });
      }
    });
  };

  render() {
    // const { mypermission } = this.props;
    const { routes, logo } = this.props;
    const pathnameKey = localStorage.getItem("key");
    let navbarBrandProps;
    if (logo && logo.innerLink) {
      if (pathnameKey === "writer") {
        navbarBrandProps = {
          // to: logo.innerLink,
          to: "/admin/writer/dashboard-writer",
          tag: Link
        };
      }
      if (pathnameKey === "editor") {
        navbarBrandProps = {
          // to: logo.innerLink,
          to: "/admin/editor/dashboard-editor",
          tag: Link
        };
      }
      if (pathnameKey === "admin") {
        navbarBrandProps = {
          // to: logo.innerLink,
          to: "/admin/settings/employee/writer",
          tag: Link
        };
      }
      if (pathnameKey === "chiefeditor") {
        navbarBrandProps = {
          // to: logo.innerLink,
          to: "/admin/chief/dashboard-chief",
          tag: Link
        };
      }
    } else if (logo && logo.outterLink) {
      navbarBrandProps = {
        href: logo.outterLink,
        target: "_blank"
      };
    }
    const scrollBarInner = (
      <div className="scrollbar-inner">
        <div className="sidenav-header d-flex align-items-center">
          {logo ? (
            <NavbarBrand {...navbarBrandProps}>
              <img
                alt={logo.imgAlt}
                className="navbar-brand-img"
                src={logo.imgSrc}
                // width={"80px"}
              />
            </NavbarBrand>
          ) : null}
          <div className="ml-auto">
            <div
              className={classnames("sidenav-toggler d-xl-block", {
                unactive: this.props.sidenavOpen
              })}
              onClick={this.props.toggleSidenav}
            >
              <div className="sidenav-toggler-inner">
                <i className="sidenav-toggler-line" />
                <i className="sidenav-toggler-line" />
                <i className="sidenav-toggler-line" />
              </div>
            </div>
          </div>
        </div>
        <div className="navbar-inner">
          <Collapse navbar isOpen={true}>
            <Nav navbar>{this.createLinks(routes)}</Nav>
          </Collapse>
        </div>
      </div>
    );
    return (
      <Navbar
        className="sidenav navbar-vertical fixed-left navbar-expand-xs navbar-light bg-white"
        onMouseEnter={this.onMouseEnterSidenav}
        onMouseLeave={this.onMouseLeaveSidenav}
      >
        {navigator.platform.indexOf("Win") > -1 ? (
          <PerfectScrollbar>{scrollBarInner}</PerfectScrollbar>
        ) : (
          scrollBarInner
        )}
      </Navbar>
    );
  }
}

Sidebar.defaultProps = {
  routes: [{}],
  toggleSidenav: () => {},
  sidenavOpen: false
};

Sidebar.propTypes = {
  // function used to make sidenav mini or normal
  toggleSidenav: PropTypes.func,
  // prop to know if the sidenav is mini or normal
  sidenavOpen: PropTypes.bool,
  // links that will be displayed inside the component
  routes: PropTypes.arrayOf(PropTypes.object),
  // logo
  logo: PropTypes.shape({
    // innerLink is for links that will direct the user within the app
    // it will be rendered as <Link to="...">...</Link> tag
    innerLink: PropTypes.string,
    // outterLink is for links that will direct the user outside the app
    // it will be rendered as simple <a href="...">...</a> tag
    outterLink: PropTypes.string,
    // the image src of the logo
    imgSrc: PropTypes.string.isRequired,
    // the alt for the img
    imgAlt: PropTypes.string.isRequired
  })
};
const mapStateToProps = state => {
  return {
    mypermission: state.permissionReducer.mypermission
  };
};
export default connect(mapStateToProps, null)(Sidebar);
